/* Vault additions for Prestige: keeps the Vault price block in sync with the selected variant. */
(function () {
  function formatMoney(cents) {
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '${{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var scope = (event.target && event.target.closest && event.target.closest('.product-info, product-quick-buy, .quick-buy-modal')) || document;
    var blocks = scope.querySelectorAll('[data-vault-price]');
    if (!blocks.length && scope !== document) blocks = document.querySelectorAll('.product-info [data-vault-price]');
    blocks.forEach(function (block) {
      var amount = block.querySelector('[data-vault-price-amount]');
      var save = block.querySelector('[data-vault-price-save]');
      var was = block.querySelector('[data-vault-price-was]');
      var compare = block.querySelector('[data-vault-price-compare]');
      if (amount) amount.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          var label = save.getAttribute('data-label') || 'You save';
          save.textContent = label + ' ' + pct + '%';
        }
      }
      if (was) was.hidden = !onSale;
      if (compare && onSale) compare.textContent = formatMoney(variant.compare_at_price);
    });
  });
})();

/* Vault collection tabs */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-vault-tabs]').forEach(function (wrap) {
      if (wrap.__vaultTabs) return;
      wrap.__vaultTabs = true;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    if (tab) tab.click();
  });
})();
